/**
 * Zentrale HTML-Formatierung für Artikel-Inhalte
 * Wandelt Plain-Text in HTML um mit konsistenter Absatz-Behandlung
 */
export const formatContentAsHtml = (text: string): string => {
  if (!text) return '';

  const boundaryBefore = '[\\s([{"\'.,;:!?-]';
  const boundaryAfter = '[\\s)\\]}\"\'.,;:!?-]';

  // Nur saubere Delimiter matchen:
  // - Öffnendes Sternchen nach Start oder Satz-/Leerzeichen-Grenze
  // - Schließendes Sternchen vor Satz-/Leerzeichen-Grenze oder Ende
  // - Inhalt darf nicht mit Leerzeichen/Sternchen starten oder enden
  const boldRegex = new RegExp(
    `(^|${boundaryBefore})\\*\\*([^\\s*](?:[^*]*?[^\\s*])?)\\*\\*(?=$|${boundaryAfter})`,
    'g'
  );
  const italicRegex = new RegExp(
    `(^|${boundaryBefore})\\*([^\\s*](?:[^*]*?[^\\s*])?)\\*(?=$|${boundaryAfter})`,
    'g'
  );

  const applyInlineFormatting = (input: string): string => {
    // Nicht innerhalb bestehender HTML-Tags ersetzen
    const parts = input.split(/(<[^>]+>)/g);
    return parts
      .map(part => {
        if (part.startsWith('<') && part.endsWith('>')) {
          return part;
        }
        return part
          .replace(boldRegex, '$1<strong>$2</strong>')
          .replace(italicRegex, '$1<em>$2</em>');
      })
      .join('');
  };

  const lines = text.split('\n');
  const htmlParts: string[] = [];
  let listItems: string[] = [];

  const flushList = () => {
    if (listItems.length === 0) return;
    htmlParts.push(`<ul>${listItems.join('')}</ul>`);
    listItems = [];
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (!line) {
      flushList();
      continue;
    }

    if (line.startsWith('- ')) {
      const listContent = line.slice(2).trim();
      listItems.push(`<li>${applyInlineFormatting(listContent)}</li>`);
      continue;
    }

    flushList();
    htmlParts.push(`<p>${applyInlineFormatting(line)}</p>`);
  }

  flushList();
  return htmlParts.join('');
};
